import Vue from 'vue'
import axios from 'axios'; 
import {Message} from 'element-ui'
// 提交 mutations是更改Vuex状态的唯一合法方法

//点击切换到中文
export const changeZH = (state) => { 
  Vue.i18n.locale = 'zh-CN';
  localStorage.setItem('lang','zh-CN');
  state.qhText = 'zh-CN';
}
//点击切换到英文
export const changeEN = (state) => { 
  Vue.i18n.locale = 'en';
  localStorage.setItem('lang','en');
  state.qhText = 'en';
}
//最开始lang css状态
export const changeLangCss = (state) => {
  if(localStorage.getItem('lang') != null){
    state.qhText = localStorage.getItem('lang');
  }
}
//二级菜单展示
export const changeShow = (state) => { 
  // console.log(state.navStatus);
  state.navStatus = !state.navStatus;
}
//用户信息
export const setUser = (state,user) => { 
  if(user){
    state.currentUser = user;
    state.isLogin = true;
  }else if(user == null){
    state.currentUser = null;
    state.isLogin = false;
  }
}
//退出登录
export const quitUser = (state) => { 
  state.isLogin = false;
  state.currentUser = null;
}
//切换登录方式
export const loginWay = (state) => { 
  state.isUserLogin = !state.isUserLogin;
}
//获取选中nav的名字
export const setNavName = (state,name) => { 
  state.navName = name;
  state.navStatus = false;
  if(name == 'healthLife' || name == 'healthCheck' || name == 'healthInsurancePlan'){
    state.isHealth = true;
  }else{
    state.isHealth = false;
  }
}
//个人中心个人档案
export const userMsg = (state,data) => { 
  state.userMsg = data;
}
//消息提示
export const message = (state,data) => { 
  Message({
    message: data.message,
    type: data.type,
    center:data.center
  })
}
//获取体检人列表
export const getPhysical = (state) => { 
  axios.get(BASE_URL+'/exam/relatives/').then((res)=>{
    // console.log(res);
    state.phyExPeoList = res.data.data;
    state.phyExPeoList.forEach(function(element) {
      if(element.relationship == 0){
        state.allUserMsg = element;
      }
    })
  })
}

//额度明细接口
export const quotaDetails = (state) => { 
  axios.get(BASE_URL+'/exam/transactions/').then((res)=>{
    // console.log(res);
    state.quotaDetailsList = res.data.data;
  })
}





// WEBPACK FOOTER //
// ./src/store/mutations.js